module.exports = __webpack_public_path__ + "img/storage.bc11b9f.svg";